import { render, staticRenderFns } from "./ServicesBlock.vue?vue&type=template&id=efa357f2&scoped=true"
import script from "./ServicesBlock.vue?vue&type=script&lang=js"
export * from "./ServicesBlock.vue?vue&type=script&lang=js"
import style0 from "./ServicesBlock.vue?vue&type=style&index=0&id=efa357f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efa357f2",
  null
  
)

export default component.exports